module.exports = __webpack_public_path__ + "static/media/carpoolMidground.dab08931.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Carpool/carpoolMidground.svg
// module id = 930
// module chunks = 0